import A11yTabs from "a11y-tabs";

class SupportBlock {
    constructor(element) {
        // Class properties.
        this.supportBlock = element;

        this.minDonationValue = Number(this.supportBlock.dataset.minDonation);

        this.selectedTab = 0;

        this.customDonation = this.supportBlock.querySelector(
            "[data-custom-donation-input]",
        );

        this.donateAmountRadios = this.supportBlock.querySelectorAll(
            "[data-donate-amount]",
        );

        this.monthlydonateAmountRadios = this.supportBlock.querySelectorAll(
            "[data-monthly-donate-amount]",
        );

        this.membershipComponents = this.supportBlock.querySelectorAll(
            "[data-membership-component]",
        );

        this.submitDonation = this.supportBlock.querySelector(
            "[data-submit-donation]",
        );

        this.submitDonationLabel = this.supportBlock.querySelector(
            "[data-submit-donation-label]",
        );

        this.errorMessage = this.supportBlock.querySelector(
            "[data-error-message]",
        );

        this.a11yTabs = new A11yTabs(
            ".tab-list",
            '[role="tabpanel"]',
            this.selectedTab,
        );

        this.donationTextContainer = this.supportBlock.querySelector(
            `[data-donation-text-container]`,
        );

        this.monthlyDonationTextContainer = this.supportBlock.querySelector(
            `[data-monthly-donation-text-container]`,
        );

        this.donationCustomDonationContainer = this.supportBlock.querySelector(
            `[data-custom-donation-container]`,
        );

        this.parkKeeperBtn = this.supportBlock.querySelector(
            `[data-park-keeper-btn]`,
        );

        // this.parkKeeperMonthlyBtn = this.supportBlock.querySelector(
        //     `[data-park-keeper-monthly-btn]`,
        // );

        this.init();
    }

    init() {
        this.customDonation?.addEventListener("input", (event) => {
            let value = event.currentTarget.value;
            this.submitDonationLabel.innerText = `£${value}`;
        });

        // Prevent submmit if no checkbox is ticked or no custom amount.
        this.submitDonation?.addEventListener("click", (event) => {
            event.preventDefault();

            if (
                !this.anySingleDonationChecked() ||
                this.customDonation.value.length == 0
            ) {
                this.errorMessage.style.display = "none";
            } else {
                this.errorMessage.style.display = "";
            }
        });

        this.handleSingleDonationRadios();

        this.handleMonthlyDonationRadios();
    }

    handleSingleDonationRadios() {
        this.donateAmountRadios?.forEach((radioBtn) => {
            radioBtn?.addEventListener("click", (event) => {
                if (this.customDonation) {
                    let radioVal = radioBtn.value;

                    this.submitDonationLabel.innerText = `£${radioVal}`;
                    this.errorMessage.style.display = "none";

                    // Show/Hide upsell button.
                    if (radioVal >= this.minDonationValue) {
                        this.donationTextContainer.setAttribute(
                            "aria-hidden",
                            false,
                        );

                        this.parkKeeperBtn.setAttribute("aria-hidden", false);
                    } else {
                        this.donationTextContainer.setAttribute(
                            "aria-hidden",
                            true,
                        );

                        this.parkKeeperBtn.setAttribute("aria-hidden", true);
                    }
                }
            });
        });
    }

    handleMonthlyDonationRadios() {
        this.monthlydonateAmountRadios?.forEach((radioBtn) => {
            radioBtn?.addEventListener("click", (event) => {
                let radioVal = radioBtn.value;

                // Show/Hide upsell text.
                if (radioVal >= this.minDonationValue) {
                    this.monthlyDonationTextContainer.setAttribute(
                        "aria-hidden",
                        false,
                    );
                } else {
                    this.monthlyDonationTextContainer.setAttribute(
                        "aria-hidden",
                        true,
                    );
                }

                // Handle spektrix memberships (monthly donation) visibility.
                let controlId = radioBtn.getAttribute("aria-controls");

                this.membershipComponents.forEach((spektrixBtn) => {
                    let submitBtn = spektrixBtn.querySelector(
                        `[data-submit-membership]`,
                    );

                    if (spektrixBtn.id == controlId) {
                        spektrixBtn.style.display = "";
                        submitBtn.disabled = false;

                        let currentParkKeeperBnt = spektrixBtn.querySelector(
                            `[data-park-keeper-monthly-btn]`,
                        );

                        // Show/Hide upsell button.
                        if (radioVal >= this.minDonationValue) {
                            currentParkKeeperBnt?.setAttribute(
                                "aria-hidden",
                                false,
                            );
                        } else {
                            currentParkKeeperBnt?.setAttribute(
                                "aria-hidden",
                                true,
                            );
                        }
                    } else {
                        spektrixBtn.style.display = "none";
                        submitBtn.disabled = false;
                    }
                });
            });
        });
    }

    getActiveTab() {
        if (this.a11yTabs.tabs.length) {
            let filtered = this.a11yTabs.tabs.filter((tab) => {
                return tab.classList.contains("active");
            });

            return filtered[0] ?? false;
        }

        return false;
    }

    anySingleDonationChecked() {
        let anyChecked = false;

        this.donateAmountRadios?.forEach((radio) => {
            if (radio.checked) {
                anyChecked = true;
            }
        });

        return anyChecked;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const supportBlocks = document.querySelectorAll("[data-support-block]");

    supportBlocks.forEach((element) => {
        new SupportBlock(element);
    });
});

export default SupportBlock;
